import validate from "/home/les/work/depalop/etmflex/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import _0_45auth_45global from "/home/les/work/depalop/etmflex/frontend/middleware/0.auth.global.js";
import manifest_45route_45rule from "/home/les/work/depalop/etmflex/frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _0_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}